<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'

const props = defineProps<{
  reviewData: any
}>()

const advantages = computed(() => attributes.value.advantages)
const attributes = computed(() => props.reviewData.attributes)
const authorName = computed(() => props.reviewData.meta.authorName)
const comment = computed(() => attributes.value.comment)
const disadvantages = computed(() => attributes.value.disadvantages)
const formattedCreationDateInMsk = computed(() => getFormattedDateInMsk(attributes.value.createdAt))
const formattedReplyCreationDateInMsk = computed(() => getFormattedDateInMsk(replyCreatedAt.value))
const isAnonymous = computed(() => attributes.value.isAnonymous)
const reply = computed(() => attributes.value.reply)
const replyCreatedAt = computed(() => attributes.value.replyCreatedAt)
const scoreAsNumber = computed(() => attributes.value.score)
const textBlocks = computed(() => [
  { title: 'Достоинства', content: advantages.value },
  { title: 'Недостатки', content: disadvantages.value },
  { title: 'Комментарий', content: comment.value }
])

function getFormattedDateInMsk (dateTime: string): string {
  return helpers.formatDateTime(dateTime, constants.dateTimeFormats.dateFull)
}
</script>

<template>
  <BlockWithBorder>
    <div class="review-card-top flex flex-wrap items-center justify-between">
      <div class="review-card-top-left">
        {{ helpers.getReviewAuthorName(authorName, isAnonymous) }}
      </div>
      <div class="review-card-top-right flex items-center">
        <span v-if="reviewData.attributes.createdAt" class="creation-date">{{ formattedCreationDateInMsk }}</span>

        <Score :score="scoreAsNumber" />
      </div>
    </div>

    <div v-if="advantages || disadvantages || comment" class="review-card-bottom mt-5">
      <template v-for="x in textBlocks">
        <div v-if="x.content" :key="x.title" class="text-block">
          <div class="text-block-title">
            {{ x.title }}
          </div>
          <pre class="pre-wrap">{{ x.content }}</pre>
        </div>
      </template>
    </div>

    <BlockWithBorder v-if="reply" class="mt-6">
      <div class="flex flex-wrap items-center justify-between">
        <span class="flex items-center justify-center text-[18px] font-bold text-main-green">
          iTAB
          <SvgIcon class="ml-1" name="outlined/check-circle" />
        </span>

        <span v-if="replyCreatedAt">{{ formattedReplyCreationDateInMsk }}</span>
      </div>
      <pre class="pre-wrap mt-5">{{ reply }}</pre>
    </BlockWithBorder>
  </BlockWithBorder>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.review-card-bottom {
  .text-block {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    & > .text-block-title {
      color: color.mix(variables.$main-gray-color, white, 60%);
      margin-bottom: 10px;
    }
  }
}

.review-card-top {
  font-size: 18px;

  @media screen and (max-width: 480px) {
    display: block;
  }

  & > .review-card-top-left {
    font-weight: 700;

    @media screen and (max-width: 480px) {
      margin-bottom: 5px;
    }
  }

  & > .review-card-top-right {
    @media screen and (max-width: 480px) {
      display: block;
    }

    & > .creation-date {
      font-size: 16px;
      margin-right: 15px;

      @media screen and (max-width: 480px) {
        display: block;
        margin-bottom: 5px;
        margin-right: 0;
      }
    }
  }
}
</style>
